import Component from '@averyano/core/src/classes/Component';
import each from 'lodash/each';
import CheckoutForm from './form';
import CartController from './cart-controller';
import axios from 'axios';
import GSAP from 'gsap';
export default class CheckoutContact extends Component {
	constructor(el) {
		super({
			element: '.popup--checkout',
			elements: {
				singlelines: '.contact__form-input',
				select: '#country',
				textareas: '.contact__form-textarea',
				checkboxservices: '.checkbox__input--services',
				checkboxgroup: '.checkbox__group',
				countryselect: '#country',
				npSearch: '#npsearch',
				npSearchResults: '#npsearch-results',
				npSearch2: '#npsearch2',
				npSearch2wrapper: '#npsearch2-wrapper',
				npSearchResults2: '#npsearch-results2',
				npTooltip: '#npsearch-wrapper .np__tooltip',
				npTooltip2: '#npsearch2-wrapper .np__tooltip',
				enWrapper: '.contact__form-group-wrapper--en',
				uaWrapper: '.contact__form-group-wrapper--ua',
			},
		});
		this.id = 'contact';
		this.isFetchedCity = false;
		this.isFetchedBranch = false;
		this.citiesList = [];
		this.branchesList = [];
		this.fetchTimer = null;
	}

	create() {
		this.isFetchedCity = false;
		this.isFetchedBranch = false;
		this.elements.select.innerHTML = '';

		let htmlCode =
			'<option value="" disabled="disabled" selected="selected"></option>';

		// if locale = ua, put "Україна" as the first option
		let sortedCountries = this.sortCountries();

		each(sortedCountries, (country) => {
			htmlCode += `<option value="${country.value}">${country['name']}</option>`;
		});

		this.elements.select.innerHTML = htmlCode;

		if (window.locale === 'ua') {
			CartController.setCustomerCountry('Ukraine');
			this.elements.select.value = CartController.getCustomerCountry();
			this.elements.select.classList.add('contact__form-input--filled');
			// Leave only Ukraine, remove other countries

			// find option with value "Ukraine" and set it as selected
			this.elements.select.querySelector(
				'option[value="Ukraine"]'
			).selected = true;
		}

		// if (this.template != this.id) return;

		// if (!this.isReady) super.createComponent();

		// if (!this.isCreated) {
		this.components = {
			form: new CheckoutForm({
				url: FN_URL.createOrder,
			}),
		};
		this.isCreated = true;
		// }

		this.checkFields();
		this.addEventListeners(); // @TODO DOUBLE CHECK
		// Create Components
		each(this.components, (component) => {
			component.create();
		});
		this.toggleCountryWrapper();
		console.log(`🔼 ${this.id} is created`);
	}

	sortCountries() {
		let sortedCountries = STORECOUNTRIES.delivery[window.locale];
		console.log(sortedCountries);

		sortedCountries = sortedCountries.sort((a, b) => {
			return a['name'].localeCompare(b['name']);
		});

		return sortedCountries;
		if (window.locale === 'ua') {
			sortedCountries = sortedCountries.sort((a, b) => {
				if (a.ua === 'Україна') return -1;
				if (b.ua === 'Україна') return 1;
				return a[window.locale].localeCompare(b[window.locale]);
			});
		} else {
			// alphabetically sort by locale
			sortedCountries = sortedCountries.sort((a, b) => {
				return a[window.locale].localeCompare(b[window.locale]);
			});
		}
		return sortedCountries;
	}

	submitForm() {
		this.components.form.requestSubmitForm();
	}

	checkFields() {
		each(this.elements.checkboxservices, (element) => {
			const name = element.getAttribute('name');
			if (window.services[name]) {
				element.checked = true;
			}
		});
	}

	toggleCountryWrapper() {
		const selectedCountry = CartController.getCustomerCountry();
		console.log('selectedCountry', selectedCountry);
		if (selectedCountry === 'Ukraine') {
			this.elements.uaWrapper.classList.remove('disabled');
			this.elements.enWrapper.classList.add('disabled');
		} else {
			this.elements.uaWrapper.classList.add('disabled');
			this.elements.enWrapper.classList.remove('disabled');
		}
	}

	async selectCity(cityRef, cityDescription) {
		CartController.setCustomerCityRef(cityRef);
		this.elements.npSearchResults.classList.remove('active');
		this.elements.npSearchResults.innerHTML = '';
		this.elements.npSearch.value = cityDescription;
		this.elements.npSearch.classList.add('contact__form-input--filled');
		this.isFetchedBranch = false;

		this.elements.npSearch2wrapper.classList.remove('disabled');
		this.elements.npSearch2.classList.remove('contact__form-input--filled');
		this.elements.npSearch2.value = '';
		this.elements.npSearchResults2.innerHTML = '';
		this.elements.npSearchResults2.classList.remove('active');
		// Fetch Branches

		// GSAP.set(this.elements.npTooltip2, {
		// 	autoAlpha: 1,
		// });
		// try {
		// 	this.branchesList = await axios.get(FN_URL.npFetchBranches, {
		// 		params: {
		// 			cityRef: cityRef,
		// 		},
		// 	});
		// } catch (error) {
		// 	console.error('Error fetching branches:', error);
		// 	GSAP.set(this.elements.npTooltip2, {
		// 		autoAlpha: 0,
		// 	});
		// 	this.elements.npSearchResults2.classList.add('active');
		// 	this.elements.npSearchResults2.innerHTML =
		// 		'<div class="error">Немає звʼязку з сервісами Нова Пошта. Якщо не виходить обрати відділення, впишіть адресу доставки у поле "Ваш коментар". Вибачте за незручності.</div>';
		// 	return;
		// }
		// this.isFetchedBranch = true;
		// GSAP.set(this.elements.npTooltip2, {
		// 	autoAlpha: 0,
		// });

		// console.log(this.branchesList);
	}
	async selectBranch(branchRef, branchDescription) {
		CartController.setCustomerBranchRef(branchRef);
		this.elements.npSearchResults2.classList.remove('active');
		this.elements.npSearchResults2.innerHTML = '';
		this.elements.npSearch2.value = branchDescription;
		this.elements.npSearch2.classList.add('contact__form-input--filled');
	}

	updateUi() {}

	show() {}

	hide() {
		return new Promise((resolve) => {
			this.destroy();

			GSAP.to(this.element, {
				autoAlpha: 0,
				onComplete: resolve,
			});
		});
	}

	async addEventListeners() {
		this.element.addEventListener('click', ({ target }) => {
			if (
				target.classList.contains('search-arrow-icon') ||
				target.classList.contains('search-text')
			)
				target = target.closest('.contact__form-search-item');

			if (target.classList.contains('contact__form-search-item--city')) {
				const cityRef = target.getAttribute('data-cityref');
				const cityDescription = target.innerText;
				this.selectCity(cityRef, cityDescription);
			}

			if (target.classList.contains('contact__form-search-item--branch')) {
				const branchRef = target.getAttribute('data-branchref');
				const branchDescription = target.innerText;
				this.selectBranch(branchRef, branchDescription);
			}
		});

		each(this.components, (component) => {
			if (component.addEventListeners) component.addEventListeners();
		});

		each(this.elements.singlelines, (element) => {
			element.addEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-input--filled');
				} else {
					element.classList.remove('contact__form-input--filled');
				}
			});
		});
		each(this.elements.textareas, (element) => {
			element.addEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-textarea--filled');
				} else {
					element.classList.remove('contact__form-textarea--filled');
				}
			});
		});
		this.elements.countryselect.addEventListener('change', () => {
			const selectedCountry = this.elements.countryselect.value;
			CartController.setCustomerCountry(selectedCountry);
			this.toggleCountryWrapper();
			this.$emit('updateUi');
		});

		this.elements.npSearch.addEventListener('input', async (e) => {
			const searchValue = e.target.value.trim();

			if (this.fetchTimer) {
				clearTimeout(this.fetchTimer);
			}
			if (searchValue.length > 1) {
				if (!this.isFetchedCity) {
					GSAP.set(this.elements.npTooltip, {
						autoAlpha: 1,
						display: 'flex',
					});

					this.fetchTimer = setTimeout(async () => {
						try {
							this.citiesList = await axios.get(
								FN_URL.npFetchCities,
								// 'http://127.0.0.1:5001/averyano-2023/us-central1/npFetchCities',
								{
									params: {
										search: searchValue,
									},
								}
							);

							const searchResults = this.citiesList.data.filter((city) =>
								city.Description.toLowerCase().includes(
									searchValue.toLowerCase()
								)
							);
							this.elements.npSearchResults.classList.add('active');
							this.elements.npSearchResults.innerHTML = '';
							each(searchResults, (city) => {
								const cityHtml = `<div class="contact__form-search-item contact__form-search-item--city" data-cityref="${city.Ref}"><span class="search-text">${city.Description}</span><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-arrow-icon"><path d="M0.427612 8.9138L12.9597 8.9138L7.34638 14.5271L8.65181 15.8326L16.4844 8L8.65181 0.167433L7.34638 1.47286L12.9597 7.0862L0.427612 7.0862L0.427612 8.9138Z" fill="rgb(var(--data-color-black))"/></svg></div>`;
								this.elements.npSearchResults.insertAdjacentHTML(
									'beforeend',
									cityHtml
								);
							});
						} catch (error) {
							console.error('Error fetching cities:', error);
							GSAP.set(this.elements.npTooltip, {
								autoAlpha: 0,
								display: 'none',
							});

							this.elements.npSearchResults.classList.add('active');
							this.elements.npSearchResults.innerHTML =
								'<div class="error">Немає звʼязку з сервісами Нова Пошта. Якщо не виходить обрати місто, впишіть адресу доставки у поле "Ваш коментар". Вибачте за незручності.</div>';
							return;
						}

						this.isFetchedCity = true;
						GSAP.set(this.elements.npTooltip, {
							autoAlpha: 0,
							display: 'none',
						});
					}, 500);
				} else {
					const searchResults = this.citiesList.data.filter((city) =>
						city.Description.toLowerCase().includes(searchValue.toLowerCase())
					);
					this.elements.npSearchResults.classList.add('active');
					this.elements.npSearchResults.innerHTML = '';
					each(searchResults, (city) => {
						const cityHtml = `<div class="contact__form-search-item contact__form-search-item--city" data-cityref="${city.Ref}"><span class="search-text">${city.Description}</span><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-arrow-icon"><path d="M0.427612 8.9138L12.9597 8.9138L7.34638 14.5271L8.65181 15.8326L16.4844 8L8.65181 0.167433L7.34638 1.47286L12.9597 7.0862L0.427612 7.0862L0.427612 8.9138Z" fill="rgb(var(--data-color-black))"/></svg></div>`;
						this.elements.npSearchResults.insertAdjacentHTML(
							'beforeend',
							cityHtml
						);
					});
				}
			} else {
				this.isFetchedCity = false;
				this.elements.npSearchResults.innerHTML = '';
				this.elements.npSearchResults.classList.remove('active');
			}
		});

		this.elements.npSearch2.addEventListener('input', async (e) => {
			const searchValue = e.target.value.trim();

			if (this.fetchTimer) {
				clearTimeout(this.fetchTimer);
			}

			if (searchValue.length > 1) {
				if (!this.isFetchedBranch) {
					GSAP.set(this.elements.npTooltip2, {
						autoAlpha: 1,
						display: 'flex',
					});

					this.fetchTimer = setTimeout(async () => {
						try {
							this.branchesList = await axios.get(
								FN_URL.npFetchBranches,
								// 'http://127.0.0.1:5001/averyano-2023/us-central1/npFetchBranches',
								{
									params: {
										search: searchValue,
										cityRef: CartController.getCustomerCityRef(),
									},
								}
							);

							this.isFetchedBranch = true;
							GSAP.set(this.elements.npTooltip2, {
								autoAlpha: 0,
								display: 'none',
							});

							const searchResults = this.branchesList.data.filter((branch) =>
								branch.Description.toLowerCase().includes(
									searchValue.toLowerCase()
								)
							);
							this.elements.npSearchResults2.classList.add('active');
							this.elements.npSearchResults2.innerHTML = '';
							each(searchResults, (branch) => {
								const branchHtml = `<div class="contact__form-search-item contact__form-search-item--branch" data-branchref="${branch.Ref}"><span class="search-text">${branch.Description}</span><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-arrow-icon"><path d="M0.427612 8.9138L12.9597 8.9138L7.34638 14.5271L8.65181 15.8326L16.4844 8L8.65181 0.167433L7.34638 1.47286L12.9597 7.0862L0.427612 7.0862L0.427612 8.9138Z" fill="rgb(var(--data-color-black))"/></svg></div>`;
								this.elements.npSearchResults2.insertAdjacentHTML(
									'beforeend',
									branchHtml
								);
							});
						} catch (error) {
							console.error('Error fetching branches:', error);
							GSAP.set(this.elements.npTooltip2, {
								autoAlpha: 0,
								display: 'none',
							});
							this.elements.npSearchResults2.classList.add('active');
							this.elements.npSearchResults2.innerHTML =
								'<div class="error">Немає звʼязку з сервісами Нова Пошта. Якщо не виходить обрати відділення, впишіть адресу доставки у поле "Ваш коментар". Вибачте за незручності.</div>';
							return;
						}
					}, 500);
				} else {
					if (!this.branchesList) return;
					const searchResults = this.branchesList.data.filter((branch) =>
						branch.Description.toLowerCase().includes(searchValue.toLowerCase())
					);
					this.elements.npSearchResults2.classList.add('active');
					this.elements.npSearchResults2.innerHTML = '';
					each(searchResults, (branch) => {
						const branchHtml = `<div class="contact__form-search-item contact__form-search-item--branch" data-branchref="${branch.Ref}"><span class="search-text">${branch.Description}</span><svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-arrow-icon"><path d="M0.427612 8.9138L12.9597 8.9138L7.34638 14.5271L8.65181 15.8326L16.4844 8L8.65181 0.167433L7.34638 1.47286L12.9597 7.0862L0.427612 7.0862L0.427612 8.9138Z" fill="rgb(var(--data-color-black))"/></svg></div>`;
						this.elements.npSearchResults2.insertAdjacentHTML(
							'beforeend',
							branchHtml
						);
					});
				}
			} else {
				this.isFetchedBranch = false;
				this.elements.npSearchResults2.innerHTML = '';
				this.elements.npSearchResults2.classList.remove('active');
			}
		});
	}

	removeEventListeners() {
		each(this.components, (component) => {
			component.removeEventListeners();
		});

		each(this.elements.singlelines, (element) => {
			element.removeEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-input--filled');
				} else {
					element.classList.remove('contact__form-input--filled');
				}
			});
		});

		each(this.elements.textareas, (element) => {
			element.removeEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-textarea--filled');
				} else {
					element.classList.remove('contact__form-textarea--filled');
				}
			});
		});
	}

	destroy() {
		super.destroy();
		this.removeEventListeners();

		each(this.components, (component) => {
			component.destroy();
		});
	}

	onResize() {
		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
	}
}
